<!-- chart header -->
@if (showTabs()) {
  <td-wb-tabs class="td-wb-quote-chart__tabs"
              type="secondary"
              [selectedTabId]="castToString(displayTimeSeries.value)"
              (selectedTabIdChange)="onTabChangeHandler(castToNumber($event))">
    @for (tab of displayTimeSeries.tabs; track tab; let i = $index) {
      <td-wb-tab class="td-wb-quote-chart__tab"
                 [tabId]="castToString(i)">
        <span [translate]="tab.translationId"></span>
      </td-wb-tab>
    }
  </td-wb-tabs>
  <div class="td-wb-quote-chart__tabs-dropdown">
    <td-wb-dropdown class="td-wb-quote-chart__dropdown"
                    [ngModel]="activeTab"
                    (ngModelChange)="onTabDropdownChangeHandler($event)">
      @for (tab of displayTimeSeries.tabs; track tab) {
        <td-wb-dropdown-item [value]="tab">
          <span [translate]="tab.translationId"></span>
        </td-wb-dropdown-item>
      }
    </td-wb-dropdown>
  </div>
}

@if (isHalted()) {
  <td-wb-notification notificationType="error">
    <span translate="tdWb.markets.quote.quotecharts.TRADING_HALTED"></span>
  </td-wb-notification>
}

@if (showDropdowns()) {
  <div
    class="td-wb-quote-chart__selection">
    @if (displayTimeSeries.timeRanges !== undefined) {
      <div [ngClass]="{ 'td-wb-quote-chart__multilist' : chartSize === 'compact' }"
           class="td-wb-quote-chart__input td-wb-quote-chart__ranges">
        <div id="td-wb-aria-quote-detail-time-range-title"
             class="td-wb-quote-chart__label"
             translate="tdWb.markets.quote.TIME_PERIOD"></div>
        <td-wb-split-buttons class="td-wb-quote-chart__split-buttons"
                             [ariaLabelledBy]="'td-wb-aria-quote-detail-time-range-title'"
                             [(ngModel)]="activeButtonId"
                             (ngModelChange)="onActiveButtonIdChangeHandler($event)">
          @for (timeRange of displayTimeSeries.timeRanges; track trackByTimeRangeType(idx, timeRange); let
            idx = $index) {
            <td-wb-split-button class="td-wb-split-button--white"
                                [value]="idx + 1">
              <td-wb-split-button-title>
                <span [translate]="timeRange.translationId"></span>
              </td-wb-split-button-title>
            </td-wb-split-button>
          }
        </td-wb-split-buttons>
        <td-wb-dropdown class="td-wb-quote-chart__dropdown"
                        id="td-wb-quote-chart-time-range-dropdown"
                        aria-labelledby="td-wb-aria-quote-detail-time-range-title"
                        name="timePeriodDropdown"
                        [ngModel]="displayTimeSeries.selectTimeRange"
                        (ngModelChange)="onTimeRangeChangeHandler($event)">
          @for (timeRange of displayTimeSeries.timeRanges; track trackByTimeRangeType($index, timeRange)) {
            <td-wb-dropdown-item
              [value]="timeRange">
              <span [translate]="timeRange.translationId + '_DROPDOWN'"></span>
            </td-wb-dropdown-item>
          }
        </td-wb-dropdown>
      </div>
    }
    @if (displayTimeSeries.frequencies !== undefined) {
      <div
        class="td-wb-quote-chart__input">
        <div id="td-wb-aria-quote-frequency-title"
             class="td-wb-quote-chart__label"
             translate="tdWb.markets.quote.FREQUENCY"></div>
        <td-wb-dropdown aria-labelledby="td-wb-aria-quote-frequency-title"
                        id="td-wb-quote-chart-frequency-dropdown"
                        name="frequencyDropdown"
                        [ngModel]="displayTimeSeries.selectFrequency"
                        (ngModelChange)="onFrequencyChangeHandler($event)">
          @for (frequency of displayTimeSeries.frequencies; track frequency) {
            <td-wb-dropdown-item
              [value]="frequency">
              <span
                [translate]="chartSize === 'compact'? frequency.translationId + '_SHORTENED': frequency.translationId"></span>
            </td-wb-dropdown-item>
          }
        </td-wb-dropdown>
      </div>
    }
    @if (displayTimeSeries.types !== undefined) {
      <div class="td-wb-quote-chart__input">
        <div id="td-wb-aria-quote-chart-control-title"
             class="td-wb-quote-chart__label"
             translate="tdWb.markets.quote.CHART_TYPE"></div>
        <td-wb-dropdown class="td-wb-dropdown--min-width-unset"
                        aria-labelledby="td-wb-aria-quote-chart-control-title"
                        name="chartControlDropdown"
                        id="td-wb-quote-chart-control-dropdown"
                        [ngModel]="displayTimeSeries.selectType"
                        (ngModelChange)="onTypeChangeHandler($event)">
          @for (item of displayTimeSeries.types; track trackByChartType($index, item)) {
            <td-wb-dropdown-item
              [value]="item">
              <span [translate]="chartSize === 'compact'? item.translationId + '_SHORTENED': item.translationId"></span>
            </td-wb-dropdown-item>
          }
        </td-wb-dropdown>
      </div>
    }
  </div>
}

@if (showChart()) {
  <div class="td-wb-quote-chart__chart">
    <div [attr.id]="renderTo">
      <td-wb-chart class="td-wb-chart__chart"
                   [type]="'stockChart'"
                   [options]="options" />
    </div>
  </div>
} @else {
  <div class="td-wb-quote-chart__left__content">
    <div class="td-wb-quote-chart__full__content__message"
         title="tdWb.markets.quote.ATTENTION | tdWbTranslate">
      <div class=" td-wb-quote-chart__full__content__message-icon">
        <td-wb-icon size="23x19"
                    iconId="warning--small" />
      </div>
      <div class="td-wb-quote-chart__full__content__message-inner">
        <span translate="tdWb.markets.quote.NO_DATA"></span>
      </div>
    </div>
  </div>
}

